import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AllStudent from "./AllStudent";

const AllStudentLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="All Student" />
      <AllStudent />
    </MasterLayout>
  );
};

export default AllStudentLayout;
